/**
 * Set the cookie.
 * @param {string} name
 * @param {string} value
 * @param {number} days
 */
const createCookie = function(name, value, days) {
	let expires;
    if (!days) {
		// 10 years
        days = 3650;
    }
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * days));
		// Note: Do not let this cookie expire past 2038 or it instantly expires. http://en.wikipedia.org/wiki/Year_2038_problem
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

export default createCookie;
